export const environment = {
  STRIPE_PK:
    'pk_live_51SqHfeKMj9OlZhnte1Ra3TD4W36WvGE41HYoisyQM1TV5uV2lwgLFYQZvS2sXxpF7Jl1E84csVeC52aTAAHhMDq500LHIaIJtl',
  BASE_API: 'https://api.amarilishealthychef.com',
  AUTH0_DOMAIN: 'dev-cmlljyxazkwdsvkg.us.auth0.com',
  AUTH0_CLIENT_ID: '3YWDo0xnGhBxhtU26GSP8dzd2uXZDMG0',
  AUTH0_AUDIENCE_DOMAIN: 'https://amarilishealthychef.com/',
};
